/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/lightbulb_medium'
export default icon
